// externals
import React from 'react';

// components
import DealSummaryItem from '../common/DealSummaryItem';

export const EmptyField = () => {
    return <DealSummaryItem label="--" value="--" isEmpty />;
};
